module.exports = __webpack_public_path__ + "img/kiko-body.a76b89ed.png";